import { create } from 'zustand';
import { checkNickname, getUserInfo, getAddressList } from '@/api/user';
import webSee from '@yaww-websee/core';
import { isAiXueApp, getValueFromUserAgent } from '@/utils/ua';

export type Address = {
  addressId?: number | string;
  provinceName: string;
  provinceId: string;
  cityName: string;
  cityId: string;
  districtName: string;
  districtId: string;
  address: string;
  mobile: string;
  isDefault: 1 | 2;
  userName: string;
  appEncryptMobile: string;
};
export type User = { [key: string]: any } | null;

type State = {
  token: string;
  user: User;
  needFillName: boolean;
  setUser: (u: User) => void;
  getUser: (forceUpdate?: boolean) => Promise<User>;
  setNeedFillName: (u: boolean) => void;
  checkNickname: () => Promise<void>;
  addressList: Address[];
  setAddressList: (u: Address[]) => void;
  getAddressList: (forceUpdate?: boolean) => Promise<Address[]>;
  setToken: (token: string) => void;
  clearToken: () => void;
  logout: () => void;
};

function getToken() {
  if (isAiXueApp()) {
    const tokenMatch = getValueFromUserAgent('rememberToken');
    if (tokenMatch) {
      localStorage.setItem('__ax__token', tokenMatch);
      return tokenMatch;
    }
  }
  return localStorage.getItem('__ax__token') || '';
}

export const useUserStore = create<State>((set, get) => ({
  user: null,
  needFillName: false,
  addressList: [],
  token: getToken(),

  setToken: (token) => {
    set({ token });
    localStorage.setItem('__ax__token', token);
  },

  clearToken: () => {
    set({ token: '', user: null });
    localStorage.removeItem('__ax__token');
  },

  logout: () => {
    set({ token: '', user: null, addressList: [] });
    localStorage.removeItem('__ax__token');
  },

  setAddressList: (u) => set({ addressList: u }),
  setUser: (u) => set({ user: u }),
  getUser: async (forceUpdate = false) => {
    if (!forceUpdate) {
    const user = get().user;
      if (user) return user;
    }
    const res = await getUserInfo();
    webSee.updateBaseOption({ user_id: res.data?.id });
    set({ user: res.data });
    return res;
  },
  setNeedFillName: (needFillName) => set({ needFillName }),
  checkNickname: async () => {
    const res = await checkNickname();
    set({ needFillName: res.data.need_fill_name });
  },
  getAddressList: async (forceUpdate = false) => {
    if (!forceUpdate) {
      const addressList = get().addressList;
      if (addressList.length > 0) return addressList;
    }
    const res = await getAddressList();
    const list = (res.data || []).map((item: Address) => ({
      ...item,
      provinceId: Number(item.provinceId),
      cityId: Number(item.cityId),
      districtId: Number(item.districtId),
    }));
    set({ addressList: list });
    return list;
  },
}));
